module.exports = __webpack_public_path__ + "img/8.54b39606.jpg";